import Success from "../components/Success";
import { Grid } from "@mui/material";
import translations from "../translations/french.json";
import Wrapper from "../components/Wrapper";

const SuccessFr = () => {
  return (
    <Wrapper lang="fr">
      <Grid container alignItems="center" justifyContent="center">
        <Success translations={translations.success} />
      </Grid>
    </Wrapper>
  );
};

export default SuccessFr;
